<ng-content />

<table
  #dropList="cdkDropList"
  class="table w-100 mat-mdc-table mdc-data-table__table"
  style="min-height: 100px; min-width: auto"
  cdkDropList
  [cdkDropListData]="reviewTargets"
  [cdkDropListConnectedTo]="connectedTo"
  (cdkDropListDropped)="drop.emit($event)"
  [id]="id"
>
  <thead *ngIf="reviewTargets.length > 0">
    <tr class="mat-mdc-header-row mdc-data-table__header-row">
      <th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col" style="width: 148px">
        Logo
      </th>

      <!--<th class="mat-mdc-header-cell mdc-data-table__header-cell" scope="col" >
        Name
      </th>-->

      <th
        class="mat-mdc-header-cell mdc-data-table__header-cell"
        scope="col"
        *ngxPermissionsOnly="['goToLocationReviewSite']"
      >
        URL
      </th>

      <th
        class="mat-mdc-header-cell mdc-data-table__header-cell"
        scope="col"
        style="width: 337px"
      >
        URL Suffix
      </th>

      <th
        class="mat-mdc-header-cell mdc-data-table__header-cell"
        scope="col"
        style="width: 186px"
      ></th>
    </tr>
  </thead>

  <tbody class="mdc-data-table__content">
    <tr
      *ngFor="let reviewTarget of reviewTargets" 
      class="mat-mdc-row mdc-data-table__row"
      cdkDrag [cdkDragDisabled]="!permissions.changeLocationsReviewSitePriority"
      [class.cant-drag]="!permissions.changeLocationsReviewSitePriority" 
      (mousedown)="onSelected.emit(reviewTarget)" 
    >
      <td class="mat-mdc-cell mdc-data-table__cell mat-column-logo" style="min-width: 148px">
        <div *ngIf="!reviewTarget.logo" class="initial-letter">
          <p>{{ reviewTarget.name.charAt(0) }}</p>

        </div>

        <img *ngIf="!!reviewTarget.logo" [src]="reviewTarget.logo" />
      </td>

      <!--<td class="mat-mdc-cell mdc-data-table__cell mat-column-name">
        {{ reviewTarget.name }}
      </td>-->

      <td
        class="mat-mdc-cell mdc-data-table__cell mat-column-url text-truncate"
        style="max-width: 463px"
        *ngxPermissionsOnly="['goToLocationReviewSite']"
      >
        <a href="{{reviewTarget.prefix + reviewTarget.url}}" target="_blank">
          {{ reviewTarget.prefix + reviewTarget.url }}
        </a>

        <ng-container *ngIf="reviewTarget.custom">
          <br>
          Not eligable for monitoring
        </ng-container>
      </td>

      <td 
        class="mat-mdc-cell mdc-data-table__cell mat-column-urlSuffix"
        style="min-width: 337px"
        *ngxPermissionsOnly="['changeLocationsReviewSiteUrlSuffix']"   
      >
        <ng-container *ngIf="!(reviewTarget | isGoogle) || ((reviewTarget | isGoogle) && !(reviewTarget | isIntegratedWithGmb))">
          <div class="d-flex align-items-center">
            <input
              #urlSuffix
              class="form-control my-1"
              name="indeeeex"
              type="text"
              [value]="reviewTarget.url"
              (mousedown)="$event.stopPropagation()"
            />

            <button
              class="btn btn-lg btn-outline-primary ms-2 px-2"
              [disabled]="reviewTarget.url.length == 0"
              (click)="changeUrl.emit({ reviewTarget: reviewTarget, url: urlSuffix.value.trim() })"
            >
              OK
            </button>
          </div>

          <div
            *ngIf="reviewTarget | isZillow" 
            class="d-flex align-items-center my-1"
          >
              <input
                #campaignUrlSuffix
                class="form-control"
                name="index"
                ngbTooltip="Campaign URL suffix"
                type="text"
                [value]="reviewTarget | zillowCallActionUrlSuffix"
              />

              <button
                class="btn btn-lg btn-outline-primary ms-2 px-2"
                [disabled]="(reviewTarget | zillowCallActionUrlSuffix).length == 0"
                (click)="changeCampaignUrl.emit({ reviewTarget: reviewTarget, url: campaignUrlSuffix.value.trim() })"
              >
                OK
              </button>
            </div>
        </ng-container>
      </td>

      <td
        class="mat-mdc-cell mdc-data-table__cell mat-column-actions actions-cell"
        style="min-width: 186px; overflow: visible; padding: 0"
      >
        <div class="d-flex justify-content-end align-items-center w-100 position-absolute top-0 right-0">
          <div
            *ngIf="((reviewTarget | isGoogle) && !(reviewTarget | isIntegratedWithGmb) && permissions.addReviewSiteToLocation) | isGmbEnabled"
          >
            <button
              (click)="loginToGoogle.emit(reviewTarget)"
              class="btn btn-dark btn-integration-login d-flex justify-content-start align-items-center border-0 rounded-0 px-2"
              style="background-color: #2E3D4F"
            >
              <svg width="16px" height="16px"><use href="/assets/icons.svg#google" /></svg>

              <span class="ms-2 fw-normal">Sign in with Google</span>
            </button> 
          </div>

          <div
            *ngIf="((reviewTarget | isFacebook) && !(reviewTarget | isIntegratedWithFacebook) && permissions.addReviewSiteToLocation) | isFacebookEnabled"
          >
            <button
              class="btn btn-primary btn-integration-login d-flex justify-content-start align-items-center border-0 rounded-0 px-2"
              style="background-color: #1877F2"
              (click)="loginToFacebook.emit(reviewTarget)"
            >
              <img
                src="../../../../assets/images/facebook-icon-circle.png"
                width="16px"
              />

              <span class="ms-1 fw-normal">Log in with Facebook</span>
            </button> 
          </div>
        </div>

        <div
          class="actions d-flex justify-content-end align-items-center me-2"
          [class.actions-below-button]="permissions.addReviewSiteToLocation && ((((reviewTarget | isFacebook) && !(reviewTarget | isIntegratedWithFacebook)) | isFacebookEnabled) || (((reviewTarget | isGoogle) && !(reviewTarget | isIntegratedWithGmb)) | isGmbEnabled))">
          <ng-container
            *ngIf="((reviewTarget | isGoogle) && (reviewTarget | isIntegratedWithGmb) && permissions.addReviewSiteToLocation) | isGmbEnabled"
          >
            <button
              class="btn btn-borderless p-1"
              type="button"
              (click)="editGmbIntegration(reviewTarget)"
              ngbTooltip="Edit your Google My Business connection"
            >
              <!-- <i
                *ngIf="reviewTarget.error"
                class="fas fa-exclamation-circle gmb-warn"
                [ngbTooltip]="reviewTarget | reviewTargetErrorMessage"
              ></i>
              <svg width="16px" height="16px"><use href="/assets/icons.svg#google" /></svg> -->
                <i
                  *ngIf="reviewTarget.error"
                  [ngbTooltip]="reviewTarget | reviewTargetErrorMessage">
                  <svg 
                    class="icon-info"
                    style="margin-left: 15px"
                    width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6.5" cy="6.5" r="6.5" fill="red"/>
                    <path d="M6.55452 3.93867C6.26467 3.93867 6.04896 3.87801 5.90741 3.75667C5.76585 3.6286 5.69507 3.44323 5.69507 3.20056C5.69507 2.95115 5.76585 2.76578 5.90741 2.64445C6.04896 2.51638 6.26467 2.45234 6.55452 2.45234C6.84437 2.45234 7.06007 2.51638 7.20163 2.64445C7.34319 2.76578 7.41396 2.95115 7.41396 3.20056C7.41396 3.44323 7.34319 3.6286 7.20163 3.75667C7.06007 3.87801 6.84437 3.93867 6.55452 3.93867ZM7.24207 4.66667V9.72223H5.85685V4.66667H7.24207Z" fill="white"/>
                  </svg>
                </i>
            </button> 
          </ng-container>

          <ng-container
            *ngIf="((reviewTarget | isFacebook) && (reviewTarget | isIntegratedWithFacebook) && permissions.addReviewSiteToLocation) | isFacebookEnabled"
          >
            <button 
              (click)="loginWithFacebookOrChangeIntegration(reviewTarget)" 
              class="btn btn-borderless p-1" 
              ngbTooltip="Edit your Facebook connection"
            >
              <!-- <i
                *ngIf="reviewTarget.error"
                class="fas fa-exclamation-circle gmb-warn"
                [ngbTooltip]="reviewTarget | reviewTargetErrorMessage"
              ></i> -->
              <i
                *ngIf="reviewTarget.error"
                [ngbTooltip]="reviewTarget | reviewTargetErrorMessage">
                <svg 
                  class="icon-info"
                  style="margin-left: 15px"
                  width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6.5" cy="6.5" r="6.5" fill="red"/>
                  <path d="M6.55452 3.93867C6.26467 3.93867 6.04896 3.87801 5.90741 3.75667C5.76585 3.6286 5.69507 3.44323 5.69507 3.20056C5.69507 2.95115 5.76585 2.76578 5.90741 2.64445C6.04896 2.51638 6.26467 2.45234 6.55452 2.45234C6.84437 2.45234 7.06007 2.51638 7.20163 2.64445C7.34319 2.76578 7.41396 2.95115 7.41396 3.20056C7.41396 3.44323 7.34319 3.6286 7.20163 3.75667C7.06007 3.87801 6.84437 3.93867 6.55452 3.93867ZM7.24207 4.66667V9.72223H5.85685V4.66667H7.24207Z" fill="white"/>
                </svg>
              </i>
            </button> 
          </ng-container>

          <svg class="icon-move m-1" ngbTooltip="Reorder" width="14.5px" height="14.5px" style="cursor: grab">
            <use href="/assets/icons.svg#move" />
          </svg>

          <button
            *ngxPermissionsOnly="['changeLocationsReviewSitePriority']"
            class="btn btn-borderless p-1"
            ngbTooltip="Move to top"
            type="button"
            (click)="toTop.emit(reviewTarget)"
          >
            <svg class="icon-top" width="16.5px" height="16.5px">
              <use href="/assets/icons.svg#top" />
            </svg>
          </button>

          <button
            *ngxPermissionsOnly="['changeLocationsReviewSitePriority']"
            class="btn btn-borderless p-1"
            ngbTooltip="Move to bottom"
            type="button"
            (click)="toBottom.emit(reviewTarget)"
          >
            <svg class="icon-bottom" width="16.5px" height="16.5px">
              <use href="/assets/icons.svg#bottom" />
            </svg>
          </button>

          <button
            *ngxPermissionsOnly="['deleteLocationReviewSites']"
            class="btn btn-borderless p-1"
            ngbTooltip="Delete"
            type="button"
            (click)="delete.emit(reviewTarget)"
          >
            <svg class="icon-delete-grey" width="16.5px" height="16.5px">
              <use href="/assets/icons.svg#delete-grey" />
            </svg>
          </button>
        </div>
      </td>
    </tr>
  </tbody>
</table>
